// Firebase configuration for Resume Tailor App
// Uses REACT_APP_* env vars for per-environment config (dev/staging/prod)

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDhzMy60V_Zlwtg8e10KQ56L0MXwM_NFlw",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "rankify-dev.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "rankify-dev",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "rankify-dev.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "272967875694",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:272967875694:web:fc5aad8fb36d9f16ba7a7f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

export { auth, db, googleProvider };
export default app;
